"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
const toastContext_1 = require("../../context/toast/toastContext");
const useToast = () => {
    const { toastRef } = (0, toastContext_1.useToastContext)();
    const showSuccess = (message) => {
        toastRef.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: message,
            life: 5000,
        });
    };
    const showError = (message) => {
        toastRef.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: message,
            life: 5000,
        });
    };
    const showInfo = (message) => {
        toastRef.current?.show({
            severity: 'info',
            summary: 'Info',
            detail: message,
            life: 5000,
        });
    };
    const showWarning = (message) => {
        toastRef.current?.show({
            severity: 'warn',
            summary: 'Warning',
            detail: message,
            life: 5000,
        });
    };
    return {
        showSuccess,
        showError,
        showInfo,
        showWarning,
    };
};
exports.useToast = useToast;
